import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import LinkWrapper from "@/components/linkWrapper";
import MarkdownWrapper from "@/components/markdownWrapper";

export const query = graphql`
  fragment HeroSimpleCenteredData on StrapiComponentHeroSimpleCentered {
    title
    topic
    description
    callToActions {
      ...StrapiSharedLink
    }
  }
`;

function SimpleCentered({ data }) {
  if (!data) {
    return <template />;
  }
  let highlightButton;
  let buttons;
  if (data.callToActions) {
    buttons = [...data.callToActions];
    highlightButton = buttons.shift();
  }
  return (
    <div className="relative overflow-hidden bg-background-off-white">
      <div
        className="hidden sm:absolute sm:inset-y-0 sm:block sm:h-full sm:w-full"
        aria-hidden="true"
      >
        <div className="relative mx-auto h-full max-w-7xl">
          <svg
            className="absolute right-full translate-x-1/4 translate-y-1/4 transform lg:translate-x-1/2"
            width={404}
            height={784}
            fill="none"
            viewBox="0 0 404 784"
          >
            <defs>
              <pattern
                id="f210dbf6-a58d-4871-961e-36d5016a0f49"
                x={0}
                y={0}
                width={20}
                height={20}
                patternUnits="userSpaceOnUse"
              >
                <rect
                  x={0}
                  y={0}
                  width={4}
                  height={4}
                  className="text-text-light-gray"
                  fill="currentColor"
                />
              </pattern>
            </defs>
            <rect
              width={404}
              height={784}
              fill="url(#f210dbf6-a58d-4871-961e-36d5016a0f49)"
            />
          </svg>
          <svg
            className="absolute left-full -translate-x-1/4 -translate-y-3/4 transform md:-translate-y-1/2 lg:-translate-x-1/2"
            width={404}
            height={784}
            fill="none"
            viewBox="0 0 404 784"
          >
            <defs>
              <pattern
                id="5d0dd344-b041-4d26-bec4-8d33ea57ec9b"
                x={0}
                y={0}
                width={20}
                height={20}
                patternUnits="userSpaceOnUse"
              >
                <rect
                  x={0}
                  y={0}
                  width={4}
                  height={4}
                  className="text-text-light-gray"
                  fill="currentColor"
                />
              </pattern>
            </defs>
            <rect
              width={404}
              height={784}
              fill="url(#5d0dd344-b041-4d26-bec4-8d33ea57ec9b)"
            />
          </svg>
        </div>
      </div>
      <div className="relative pb-16 pt-6 sm:pb-24">
        <main className="mx-auto mt-16 max-w-7xl px-4 sm:mt-24">
          <div className="text-center">
            {data.topic && (
              <h3 className="text-2xl tracking-tight text-text-primary sm:text-3xl">
                <span className="block xl:inline">
                  <MarkdownWrapper text={data.topic} />
                </span>
              </h3>
            )}
            {data.title && (
              <h1 className="text-4xl font-extrabold tracking-tight text-text-primary sm:text-5xl md:text-6xl">
                <span className="block xl:inline">
                  <MarkdownWrapper text={data.title} />
                </span>
              </h1>
            )}
            {data.description && (
              <MarkdownWrapper
                text={data.description}
                markdownClassName="mt-3 max-w-md mx-auto text-base text-text-secondary sm:text-lg md:mt-5 md:text-xl md:max-w-3xl"
                replaceParagraph={false}
              />
            )}
            {data.callToActions && (
              <div className="mx-auto mt-5 max-w-md sm:flex sm:justify-center md:mt-8">
                {highlightButton?.link?.url &&
                  (highlightButton?.overwriteTitle ||
                    highlightButton?.link?.title) && (
                    <div className="rounded-md shadow">
                      <LinkWrapper
                        to={highlightButton.link.url}
                        className="flex w-full items-center justify-center rounded-md border border-transparent bg-background-primary px-8 py-3 text-base font-medium text-text-white hover:bg-background-primary-dark md:px-10 md:py-4 md:text-lg"
                      >
                        {highlightButton.overwriteTitle ||
                          highlightButton.link.title}
                      </LinkWrapper>
                    </div>
                  )}
                {Boolean(data.callToActions?.length) &&
                  ((button, index) =>
                    button.link?.url &&
                    (button.overwriteTitle || button.link?.title) && (
                      <div
                        key={index}
                        className="mt-3 rounded-md shadow sm:ml-3 sm:mt-0"
                      >
                        <LinkWrapper
                          to={button.link.url}
                          className="flex w-full items-center justify-center rounded-md border border-transparent bg-background-white px-8 py-3 text-base font-medium text-text-primary hover:bg-background-off-white md:px-10 md:py-4 md:text-lg"
                        >
                          {button.overwriteTitle || button.link.title}
                        </LinkWrapper>
                      </div>
                    ))}
              </div>
            )}
          </div>
        </main>
      </div>
    </div>
  );
}

SimpleCentered.propTypes = {
  data: PropTypes.object,
};

export default SimpleCentered;
